export const AUTH_LOGOUT_REQUEST = 'auth/logout-request'
export const AUTH_LOGOUT_SUCCESS = 'auth/logout-success'
export const AUTH_LOGOUT_FAILED = 'auth/logout-failed'
